import * as yup from 'yup';
const saveNoteSchema = yup
    .object()
    .shape({
    note: yup.string().trim().required('Note is required')
})
    .defined();
export default saveNoteSchema;
